import React, { useContext, useEffect, useState } from "react";
import { Button, Table, Confirm, Form } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import EmployeeCertificateStore from "../../../app/stores/employeecertificateStore";
import { RootStoreContext } from "../../../app/stores/rootStore";
import EmployeeCertificateEditForm from "./EmployeeCertificateEditForm";
import CertificatePhotoDropzone from "../../../app/common/Dropzone/CertificatePhotoDropzone";
import EmployeeCertificatePhoto from "./EmployeeCertificatePhoto";

const EmployeeCertificate: React.FC = () => {
  const [open, setOpen] = useState(false);
  const rootStore = useContext(RootStoreContext);
  const { openModal } = rootStore.modalStore;
  const employeecertificateStore = useContext(EmployeeCertificateStore);
  const {
    employeecertificatesByDate,
    deleteEmployeeCertificate,
    loadEmployeeCertificatePhoto,
    certificateRegistry,
    changeEmployeeCertificate,
    editEmployeeCertificate,
    submitting,
    target,
  } = employeecertificateStore;
  
  const [technicianCertificateId, setEmployeeCertificateId] = useState("");
  const [certificateName, setcertificateName] = useState("");

  return (
    <Table celled unstackable compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Certificate</Table.HeaderCell>
          {/* <Table.HeaderCell>Category</Table.HeaderCell> */}
          <Table.HeaderCell>Expiry Date</Table.HeaderCell>
          <Table.HeaderCell width={1}>Action</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {employeecertificatesByDate.map((employeecertificate) => (
          <Table.Row key={employeecertificate.id}>
            <Table.Cell>
              {certificateRegistry.get(employeecertificate.certificateId).name}
            </Table.Cell>
            {/* <Table.Cell>
              {
                certificateRegistry.get(employeecertificate.certificateId)
                  .category
              }
            </Table.Cell> */}
            {employeecertificate.expiryDate < new Date().toISOString() ? (
              <Table.Cell style={{ backgroundColor: "red" }}>
                <Form.Input
                  name="expiryDate"
                  transparent
                  required
                  type='date'
                  onBlur={()=> editEmployeeCertificate(employeecertificate)}
                  onChange={(e, {name, value})=> changeEmployeeCertificate(employeecertificate, name, value)}
                  value={employeecertificate.expiryDate}
                  style={{width: '130px'}}
                    />
              </Table.Cell>
            ) : employeecertificate.expiryDate <
              new Date(
                new Date().setMonth(new Date().getMonth() + 3)
              ).toISOString() ? (
              <Table.Cell style={{ backgroundColor: "yellow" }}>
                <Form.Input
                  name="expiryDate"
                  transparent
                  required
                  type='date'
                  onBlur={()=> editEmployeeCertificate(employeecertificate)}
                  onChange={(e, {name, value})=> changeEmployeeCertificate(employeecertificate, name, value)}
                  value={employeecertificate.expiryDate}
                  style={{width: '130px'}}
                    />
              </Table.Cell>
            ) : (
              <Table.Cell>
                <Form.Input
                  name="expiryDate"
                  transparent
                  required
                  type='date'
                  onBlur={()=> editEmployeeCertificate(employeecertificate)}
                  onChange={(e, {name, value})=> changeEmployeeCertificate(employeecertificate, name, value)}
                  value={employeecertificate.expiryDate}
                  style={{width: '130px'}}
                    />
              </Table.Cell>
            )}
            <Table.Cell>
              <Button.Group vertical size="mini">
                {/* <Button
                  size="mini"
                  color="blue"
                  content="Edit"
                  onClick={() =>
                    openModal(
                      <EmployeeCertificateEditForm
                        certificate={employeecertificate}
                      />
                    )
                  }
                /> */}
                <Button
                  name={employeecertificate.id}
                  size="mini"
                  loading={target === employeecertificate.id && submitting}
                  onClick={() => {
                    setOpen(true);
                    setEmployeeCertificateId(employeecertificate.id);
                    setcertificateName(
                      certificateRegistry.get(employeecertificate.certificateId)
                        .name
                    );
                  }}
                  color="red"
                  content="Delete"
                />
                <Confirm
                  open={open}
                  onCancel={() => setOpen(false)}
                  onConfirm={(e) => {
                    deleteEmployeeCertificate(technicianCertificateId);
                    setOpen(false);
                  }}
                  content={`Are you sure you want to delete '${certificateName}' ?`}
                  confirmButton="Yes"
                  size="mini"
                  style={{
                    position: "relative",
                    maxHeight: "150px",
                    height: "auto",
                  }}
                />
                <Button
                  onClick={() => loadEmployeeCertificatePhoto(employeecertificate.technicianEmail, employeecertificate.certificateId).
                    then(() => openModal(<EmployeeCertificatePhoto certificate={certificateRegistry.get(employeecertificate.certificateId).name}/>)
                    )
                  }
                  size='mini'
                  color="green"
                  content="View"
                />
                <Button
                  size="mini"
                  color="grey"
                  content={
                    <CertificatePhotoDropzone
                      name={
                        certificateRegistry.get(
                          employeecertificate.certificateId
                        ).name
                      }
                      category="Certificate"
                    />
                  }
                />
              </Button.Group>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default observer(EmployeeCertificate);
